import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DesignationDto } from '../models/DesignationDto';
import { DesignationRequest } from '../models/requests/DesignationVm';
import { ApiResponseObject } from '../models/responses/api-response-object';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DesignationService {

  constructor(private httpClient: HttpClient) { }
  getDesignations(): Observable<ApiResponseObject<DesignationDto[]>> {
    return this.httpClient.get<ApiResponseObject<DesignationDto[]>>(`${environment.apiUrl}/Designations`);
  }
  
  saveDesignation(request: DesignationRequest): Observable<ApiResponseObject<DesignationDto>> {
   
    return this.httpClient.post<ApiResponseObject<DesignationDto>>(`${environment.apiUrl}/Designations`, request);
  }
}
